var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 53,
    rx: 14.5,
    fill: "white",
    stroke: "#ABABAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 25.2H36.2V28.9H41.7C41.6 29.8 41 31.2 39.7 32.1C38.9 32.7 37.7 33.1 36.2 33.1C33.6 33.1 31.3 31.4 30.5 28.9C30.3 28.3 30.2 27.6 30.2 26.9C30.2 26.2 30.3 25.5 30.5 24.9C30.6 24.7 30.6 24.5 30.7 24.4C31.6 22.3 33.7 20.8 36.2 20.8C38.1 20.8 39.3 21.6 40.1 22.3L42.9 19.5C41.1999 18 38.9 17 36.2 17C32.3 17 28.9 19.2 27.3 22.5C26.6 23.9 26.2 25.4 26.2 27C26.2 28.6 26.6 30.1 27.3 31.5C28.9 34.8 32.3 37 36.2 37C38.9 37 41.1999 36.1 42.7999 34.6C44.6999 32.9 45.7999 30.3 45.7999 27.2C45.7999 26.4 45.7 25.8 45.6 25.2Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButton);
export default __webpack_public_path__ + "static/media/google-button.1a80361375e115c27ae54d5f1f5f93ff.svg";
export { ForwardRef as ReactComponent };